import notifierSlice from "./notifierSlice";

export const { enqueueSnackbar, closeSnackbar, removeSnackbar, toggleNotifierMenu, dismissHistory } =
  notifierSlice.actions;